import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { VisitorParkingRequest } from "../../../Types/UnitFeatureTypes";


export interface FetchVisitorParkingInfoState {
  request: {
      loading: boolean;
      error: string | null;
      singleVisitorParkingRequest: VisitorParkingRequest | null;
      data: VisitorParkingRequest[] | null;
      count: string | null;
  };
}

export enum Types {
  FETCH_VISITOR_PARKING_REQUEST = "FETCH_VISITOR_PARKING_REQUEST",
  FETCH_VISITOR_PARKING_SUCCESS = "FETCH_VISITOR_PARKING_SUCCESS",
  FETCH_VISITOR_PARKING_FAILURE = "FETCH_VISITOR_PARKING_FAILURE",
}

const visitorParkingActions = createAsyncAction(
  Types.FETCH_VISITOR_PARKING_REQUEST,
  Types.FETCH_VISITOR_PARKING_SUCCESS,
  Types.FETCH_VISITOR_PARKING_FAILURE,
)
<
  { id?: string, offset?: number, sortColumn?: string, sortDirection?: string },
  { visitorParking?: VisitorParkingRequest,  visitorParkings?: VisitorParkingRequest[], count: string },
  { message: string }
>();

export const Actions = { visitorParkingActions };

export const initialState: FetchVisitorParkingInfoState = {
  request: {
    loading: false,
    error: null as string | null,
    singleVisitorParkingRequest: null,
    data: null,
    count: '0'
  }
};

export type FetchVisitorParkingState = typeof initialState;

const fetchVisitorParkingRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.error = null;
    draft.request.data = null;

    return draft;
  });

const fetchVisitorParkingSuccess = (
  state = initialState,
  { payload }: ActionType<typeof Actions.visitorParkingActions.success>
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.singleVisitorParkingRequest = payload.visitorParking ?? null;
    draft.request.data = payload.visitorParkings ?? null;
    draft.request.count = payload.count;
    if (draft.request.data) {
      draft.request.loading = false;
    }

    return draft;
  });

const fetchVisitorParkingFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.visitorParkingActions.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.error = payload.message;

    return draft;
  });


export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(Actions.visitorParkingActions.request, fetchVisitorParkingRequest)
  .handleAction(Actions.visitorParkingActions.success, fetchVisitorParkingSuccess)
  .handleAction(Actions.visitorParkingActions.failure, fetchVisitorParkingFailure);
  